const accountOrdersADA = (button) => {
  const expanded = button.getAttribute('aria-expanded') === 'true';
  const details = button.closest('.order').querySelector('[data-order-details]');
  button.setAttribute('aria-expanded', !expanded);
  details.setAttribute('aria-hidden', expanded);
};

export default () => {
  if (!$('.account.orders').length) {
    return;
  }

  // Redirect if coming from the Digital Bridal Studio
  // const dbs_redirect = window.localStorage.getItem('dbs-redirect-after-login');
  // if (dbs_redirect !== null) {
  //   window.localStorage.removeItem('dbs-redirect-after-login');
  //   window.location.href = dbs_redirect;
  //   return;
  // }

  $(document).on('click', '[data-view-order-details-button]', (e) => {
    const button = e.currentTarget;
    const $button = $(button);
    const $collapsed_text = $button.find('[data-collapsed-text]');
    const $expanded_text = $button.find('[data-expanded-text]');
    const $order = $button.closest('[data-order]');
    const $order_details = $order.find('[data-order-details]');

    if ($order_details.hasClass('order__expanded-info--open')) {
      $collapsed_text.show();
      $expanded_text.hide();
      $order_details.removeClass('order__expanded-info--open');
      $order_details.css('max-height', 0);

      if (!$('.order__expanded-info--open').length) {
        $('footer.shopify-section-group-footer-group').removeClass('footer--unstick');
        window.dispatchEvent(new Event('resize'));
      }
      
      // [ADA]
      accountOrdersADA(button);

      return;
    }

    $collapsed_text.hide();
    $expanded_text.show();
    $order_details.addClass('order__expanded-info--open');
    $order_details.css('max-height', $order_details.children('[data-order-details-height]').outerHeight());

    if ($('.order__expanded-info--open').length) {
      $('footer.shopify-section-group-footer-group').addClass('footer--unstick');
      window.dispatchEvent(new Event('resize'));
    }

    // [ADA]
    accountOrdersADA(button);
  });

  $(document).on('click', '[data-view-order-details-link]', (e) => {
    const $order = $(e.currentTarget).closest('[data-order]');
    $order.find('[data-view-order-details-button]').trigger('click');
  });
};
